<template>
  <div>
    <Stack>
      <SchemaField
        v-for="(value, key) in reconciliationStore.formData"
        :key="key"
        :name="key"
        :level="0"
        :schema="reconciliationStore.resolvedSchema?.properties?.[key]"
        :current-value="currentDossier[key]"
        :draft-value="draftDossier[key]"
        :form-value="value"
        :what-to-show="whatToShow"
        :show-confidence="sourceConfidence"
        @update:formData="({ path, value }) => reconciliationStore.updateFormDataSection(path, value)"
      />
    </Stack>

    <footer class="reconciliation-footer">
      <div class="controls">
        <div class="stk-select">
          <select
            v-model="whatToShow"
          >
            <option value="changes">
              Only show changes
            </option>
            <option value="context">
              Show changes with context
            </option>
            <option value="everything">
              Show everything
            </option>
          </select>
          <Icon />
        </div>

        <div class="radios">
          <label class="radio">
            <input
              v-model="sourceConfidence"
              type="checkbox"
              value="high"
            >
            <ConfidenceLevel confidence="high" />
          </label>
          <label class="radio">
            <input
              v-model="sourceConfidence"
              type="checkbox"
              value="medium"
            >
            <ConfidenceLevel confidence="medium" />
          </label>
          <label class="radio">
            <input
              v-model="sourceConfidence"
              type="checkbox"
              value="low"
            >
            <ConfidenceLevel confidence="low" />
          </label>
        </div>
      </div>

      <Buttons>
        <Button
          variant="success"
          @click="emit('save')"
        >
          Save Changes
        </Button>
        <Button
          variant="danger"
          @click="emit('cancel')"
        >
          Cancel
        </Button>
      </Buttons>
    </footer>
  </div>
</template>

<script setup>
import { defineEmits, ref, watch } from 'vue';
import SchemaField from './SchemaField.vue';
import { useReconciliationStore } from '@frontend/ui/stores/reconciliationStore.js';
import { Button, Buttons, ConfidenceLevel, Icon, Stack } from '@stakeui';

const reconciliationStore = useReconciliationStore();

const whatToShow = ref('changes');
const sourceConfidence = ref([]);

const props = defineProps({
  schema: Object,
  currentDossier: Object,
  draftDossier: Object,
});

const emit = defineEmits(['save', 'cancel']);

watch(
    () => props.schema,
    newSchema => {
      if (newSchema) {
        reconciliationStore.init(newSchema, props.draftDossier);
      }
    },
    { immediate: true },
);
</script>

<style scoped>
.reconciliation-footer {
  position: sticky;
  bottom: 1rem;
  z-index: 9;
  border-radius: 1rem;
  border-radius: 0.75rem;
  padding: 0.5rem;
  padding-left: 0.75rem;
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  box-shadow: 0 0.5em 1em rgb(0 0 0 / 5%), 0 0.25em 0.5em rgb(0 0 0 / 5%), 0 0.125em 0.25em rgb(0 0 0 / 5%);
}

.toggles {
  display: flex;
  align-items: center;
  gap: 0.25em;
}

.toggle {
  padding: 0.25em 0.5em;
  border-radius: 0.5em;
  cursor: pointer;

  &:hover {
    background-color: var(--stk-background-alt);
  }
}

.controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.radios {
  display: flex;
  align-items: center;
  gap: 0.25em;
}

.radio {
  display: flex;
  align-items: center;
  gap: 0.25em;
}
</style>
